import { render } from "./add-price-rule.template.html?vue&type=template&id=9068cd1a&scoped=true"
import script from "./AddPriceRule.vue?vue&type=script&lang=ts"
export * from "./AddPriceRule.vue?vue&type=script&lang=ts"

import "./AddPriceRule.vue?vue&type=style&index=0&id=9068cd1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9068cd1a"

export default script